"use strict";

var sortBy = require("./sortBy.js");

module.exports = sort;

function sort(arr) {
  return sortBy(a => a, arr);
}